import { Maximize2 } from 'lucide-react'

import { DialogTrigger } from '@/components/dialog'
import { Expander, ExpanderContent } from '@/components/image-expander'

import { ImageOptions } from '../monitoring-tab/map-card'

interface CarbonMapCardProps {
  img: ImageOptions
}

export function CarbonMapCard({ img }: CarbonMapCardProps) {
  const hasImage = img.highRes || img.lowRes

  if (!hasImage) {
    return (
      <div className="flex flex-col lg:w-1/3">
        <div>
          <p className="flex aspect-square w-full select-none items-center justify-center text-monochromatic-400">
            Imagem indisponível
          </p>
        </div>
      </div>
    )
  } else if (hasImage) {
    return (
      <Expander>
        <div className="lg:w-1/3">
          <DialogTrigger className="group relative w-full">
            <img
              src={img.lowRes ? img.lowRes : img.highRes}
              alt={'Imagem Marco 0'}
              onError={(e) => {
                const parent = e.currentTarget.parentElement

                if (e.currentTarget.src === img.highRes) return

                if (e.currentTarget.src === img.lowRes) {
                  e.currentTarget.onerror = null
                  e.currentTarget.src = img.highRes || ''

                  return
                }

                parent!.innerHTML = `<p class="text-monochromatic-400 justify-center flex items-center aspect-square w-full select-none">Imagem indisponível</p>`
              }}
              className="aspect-square w-full select-none rounded-sm object-cover hover:border-2 hover:border-bios-primary"
            />

            <Maximize2 className="pointer-events-none absolute left-1/2 top-1/2 size-6 -translate-x-1/2 -translate-y-1/2 rounded-lg bg-gray-400/40 p-1 text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100 md:size-8 lg:size-10" />
          </DialogTrigger>
        </div>

        {img.highRes && (
          <ExpanderContent image={img.highRes} alt="Imagem Trimestral" />
        )}
      </Expander>
    )
  }
}
